import * as React from "react";
import { memo, useEffect, useRef } from "react";
import { MovieItemView } from "./MovieItemView";
import "../block/movieBlockViewStyles.css";
import { focusManager } from "../../../utils/Focus";
export var MovieRowView = memo(function (_a) {
    var index = _a.index, movies = _a.movies, onMoviePress = _a.onMoviePress, onKeyBack = _a.onKeyBack, _b = _a.hasHorizontalScroll, hasHorizontalScroll = _b === void 0 ? true : _b, _c = _a.active, active = _c === void 0 ? true : _c;
    var containerRef = useRef(null);
    useEffect(function () {
        if (hasHorizontalScroll && containerRef.current) {
            focusManager.registerGroup({
                name: "row-" + index,
                horizontalContainer: containerRef.current,
            });
        }
    }, [index, hasHorizontalScroll]);
    return (React.createElement("div", { className: "movie-row-container" },
        React.createElement("div", { ref: containerRef, className: "block-movies-container" }, movies.map(function (m, i) { return (React.createElement(MovieItemView, { focusRaw: ["row-" + index, i], key: i + "-" + m.id, movie: m, active: active, onMoviePress: onMoviePress, onKeyBack: onKeyBack })); }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/MovieRowView.tsx
// module id = 41
// module chunks = 1